import {
  ItemListContainer,
  ItemWrapper,
  ItemInfoWrapper,
  ItemTitleWrapper,
  ColumnWrapper,
  ItemLeftWrapper,
  ItemActionsWrapper,
} from "./AppointmentsItemList.styled";
import { Typography, Tag, Icon } from "@ann/web-components";

const AppointmentsItem = ({ info }) => {
  return (
    <ItemListContainer>
      <ItemWrapper>
        <ItemLeftWrapper>
          <ItemTitleWrapper>
            <Icon name="calendarToday" size="medium" color="primary" />
            <Typography category="subtitle" weight="bold" size="medium" color="subtitle">
              {info.vehicle}
            </Typography>
          </ItemTitleWrapper>
          <ItemInfoWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                VIN
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
                maxCharacters={15}
              >
                {info.vin}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Service Mileage
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
                maxCharacters={15}
              >
                {info.serviceMileage}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Advisor
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
                maxCharacters={15}
              >
                {info.advisor}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Status
              </Typography>
              <Tag text={info.status} color={info.statusColor || "informative"} size="medium" />
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Created Via
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
                maxCharacters={20}
              >
                {info.createdVia}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small" color="subtitle">
                Timestamp
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
                maxCharacters={20}
              >
                {info.timestamp}
              </Typography>
            </ColumnWrapper>
          </ItemInfoWrapper>
        </ItemLeftWrapper>
        <ItemActionsWrapper />
      </ItemWrapper>
    </ItemListContainer>
  );
};

export default AppointmentsItem;
